module.exports = __webpack_public_path__ + "img/rise.06456836.svg";